import script from "./LogsAcessoUsuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsAcessoUsuarios.vue?vue&type=script&setup=true&lang=js"

import "./LogsAcessoUsuarios.vue?vue&type=style&index=0&id=77572c0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77572c0a"]])

export default __exports__